<template>
  <div>
    <CardCadastro size="100">
      <div slot="header">
        <h4 class="title">Galeria de Mídia / Arquivos</h4>
      </div>
      <div slot="body">
        <h5 v-html="titulo"></h5>
        <md-button
          class="md-default"
          v-if="false"
          v-on:click="botao_mostra_upload"
        >Adicionar Arquivos</md-button>

        <upload :p_parentid="id_registro" :ptype="id_tabela" v-bind:onSave="onSave" v-if="modo_edit"></upload>

        <div class="md-layout" v-if="loading">
          <div class="md-layout-item md-size-100">
            <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
            {{msg_status}} ..
          </div>
        </div>
        <div class="md-layout">
          <div v-for="(item, index) in items " :key="index" class="md-layout-item md-size-25">
            <div v-if="item.type.indexOf('image') > -1 ">
              <img v-bind:src="item.url_thumb" style="max-height: 70px; max-width: 70px; " />
            </div>
            <div v-if="item.type.indexOf('image') < 0 ">
              <md-icon style="font-size: 70px">attach_file</md-icon>
            </div>
            <a :href="item.url" target="_blank">{{item.arquivo}}</a>
            <a href="#!" v-on:click="remover(item, index)" v-if="modo_edit">
              <md-icon>delete</md-icon>
            </a>
          </div>
        </div>
      </div>
    </CardCadastro>
  </div>
</template>

<script>
import upload from "./upload.vue";
import CardCadastro from "../../../components/CardCadastro";
import service from "../../../services/ArquivoService";
import Swal from "sweetalert2";

import $ from "jquery";

export default {
  components: { upload, CardCadastro },
  props: [
    "id_registro",
    "id_tabela",
    "pShowUpload",
    "unique_id",
    "titulo",
    "onLoadData",
    "enable_edit",
  ],

  data: function() {
    return {
      action: "list",
      items: [],
      id: "",
      index_selecionado: "",
      texto_pesquisa: "",

      loading: false,
      msg_status: "Carregando",
      v_visivel_upload: false,
      img_loading: "loading.gif",
      modo_edit: true,
    };
  },
  mounted() {
    if ( this.enable_edit != null && this.enable_edit != undefined ){
      this.modo_edit = this.enable_edit;
    }
    this.loadData();
  },
  methods: {
    loadData() {
      var self = this;
      self.loading = true;

      service
        .getList(this.id_registro, this.id_tabela)
        .then(function(response) {
          console.log(response.data);
          self.items = response.data;
          self.loading = false;

          if (self.onLoadData != null) {
            self.onLoadData(response.data);
          }
        });
    },

    getID(tip) {
      return this.unique_id + tip;
    },

    show_botao_upload() {
      if (this.pShowUpload != null && this.pShowUpload == "false") {
        return false;
      }

      return true;
    },
    show_upload() {
      return this.v_visivel_upload;
    },
    botao_mostra_upload() {
      this.v_visivel_upload = !this.v_visivel_upload;
    },

    style_list() {
      if (this.action == "form" || this.action == "formsel") {
        return "display:none";
      }
      return "";
    },

    onDelete(id) {
         setTimeout(function(){

                self.loadData();
         }, 300);
    },
    onSave(response, tipo) {
      var self = this;
      console.log("onSave?", response);
      if (tipo == "upload") {
     

               if ( response != null && response != undefined ){

                       self.items = response.data;
               } else{

                     setTimeout(function(){
                         self.loadData();
                     }, 1000);

               }

            
      }
    },
    remover(item, index) {
      var self = this;

      if (!confirm("Atenção. Deseja realmente excluir este arquivo?")) {
        return false;
      }

      service.delete(item.id).then(function(response) {
        self.items.splice(index, 1);
      });

      /* Swal.fire({
        title: "Atenção!",
        html: "Deseja realmente excluir este arquivo?",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        buttonsStyling: false,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          service.delete(item.id).then(function(response) {
            self.items.splice(index, 1);
          });
        }
      }); */
    }
  }
};
</script>